const ko = {
  // Header
  'header.logoAlt': '코레밥스 로고',

  // Footer
  'footer.copyright': '© 2026 코레밥스 Stats Dashboard. All rights reserved.',
  'footer.createdBy': 'Created by Junsu Yoon #17 and Taerim Kim #66',

  // Visitor Banner
  'visitor.unavailable': '방문자 통계를 불러올 수 없습니다',
  'visitor.loading': '방문자 통계 로딩 중...',
  'visitor.today': '오늘',
  'visitor.month': '이번 달',
  'visitor.total': '전체',

  // Common
  'common.loading': '로딩 중...',
  'common.home': '메인으로',
  'common.activeRoster': '현역 로스터',
  'common.gameRecords': '경기 기록',
  'common.videos': '영상',
  'common.roster': '로스터',
  'common.admin': '관리자 모드',
  'common.allSeasons': '전체 시즌',
  'common.selectSeason': '시즌 선택',
  'common.currentSeason': '현재 시즌 선택',
  'common.player': '선수명',
  'common.date': '일자',
  'common.opponent': '상대',
  'common.score': '스코어',
  'common.season': '시즌',
  'common.status': '상태',
  'common.close': '닫기',
  'common.refresh': '새로고침',
  'common.exportCSV': 'CSV 내보내기',
  'common.myStats': '내 기록',
  'common.pinPlayerPrompt': '로스터에서 선수를 고정하면 여기서 기록을 볼 수 있습니다',
  'suffix.players': '명',
  'suffix.games': '경기',

  // App (Main Dashboard)
  'app.title': '코레밥스 선수 기록',
  'app.subtitle': 'Korebaps Stats Dashboard',
  'app.latestGame': '최근 경기',
  'app.registeredPlayers': '등록 선수',
  'app.games': '경기',
  'app.seasonSelect': '시즌 선택',
  'app.loadingSeasons': '시즌 로딩 중...',
  'app.searchPlayer': '선수 검색...',
  'app.includeRetired': '은퇴 선수 포함',
  'app.battingStats': '타격 스탯',
  'app.pitchingStats': '투구 스탯',
  'app.runsAllowed': '실점',
  'app.earnedRuns': '자책',
  'app.pitchCount': '투구수',

  // Player Detail
  'player.title': '코레밥스 선수 기록',
  'player.subtitle': 'Korebaps Stats Dashboard',
  'player.name': '선수명',
  'player.jerseyNumber': '등번호',
  'player.selectedSeason': '선택 시즌',
  'player.notFound': '선수 정보를 찾을 수 없습니다.',
  'player.inactiveMsg': '이 선수는 현재',
  'player.inactiveStatus': 'Inactive',
  'player.noAlbumArt': 'No album art',
  'player.walkupSong': 'Walkup Song',
  'player.openSpotify': 'Open in Spotify',
  'player.careerBatting': '전체 타격',
  'player.careerPitching': '전체 투구',
  'player.noBattingStats': '커리어 전체 타격 기록이 없습니다.',
  'player.noPitchingStats': '커리어 투구 기록이 없습니다.',
  'player.gameBattingStats': '경기별 타격 스탯',
  'player.battingTrend': '타격 추이 (누적 AVG/OBP/SLG)',
  'player.gamePitchingStats': '경기별 투구 스탯',
  'player.noGameRecords': '등록된 경기 기록이 없습니다.',
  'player.pinMyStats': '내 기록으로 고정',
  'player.unpinMyStats': '고정 해제',
  'player.shareLink': '공유',
  'player.linkCopied': '링크가 복사되었습니다!',
  'player.compareSeasons': '시즌 비교',
  'player.seasonA': '시즌 A',
  'player.seasonB': '시즌 B',
  'player.selectTwoSeasons': '비교할 두 시즌을 선택하세요.',

  // Player Comparison
  'compare.title': '선수 비교',
  'compare.subtitle': '두 선수를 비교합니다',
  'compare.selectPlayerA': '선수 A',
  'compare.selectPlayerB': '선수 B',
  'compare.selectTwoPlayers': '비교할 두 선수를 선택하세요.',
  'compare.batting': '타격',
  'compare.pitching': '투구',
  'common.comparePlayers': '선수 비교',

  // Active Roster
  'roster.title': '코레밥스 현역 로스터',
  'roster.subtitle': 'Korebaps Active Roster',
  'roster.totalPlayers': '총 선수',
  'roster.updated': '업데이트',
  'roster.activeRoster': 'Active Roster',
  'roster.inactiveRoster': 'Inactive Roster',
  'roster.clickExpand': '(클릭하여 열기)',
  'roster.noActive': '등록된 현역 선수가 없습니다.',
  'roster.noInactive': '등록된 비현역 선수가 없습니다.',

  // Game Records
  'games.title': '코레밥스 경기 기록',
  'games.subtitle': 'Korebaps Game Records',
  'games.totalGames': '총 경기',
  'games.selected': '선택됨',
  'games.all': '전체',
  'games.heading': '경기 기록',
  'games.sortedRecent': '최근 경기 순으로 표시됩니다.',
  'games.noRecords': '등록된 경기 기록이 없습니다.',
  'games.friendly': '연습 경기',
  'games.regular': '정규 경기',
  'games.win': '승',
  'games.loss': '패',
  'games.draw': '무',
  'games.score': '점수',

  // Game Detail
  'gameDetail.title': '코레밥스 경기 디테일',
  'gameDetail.subtitle': 'Korebaps Game Detail',
  'gameDetail.gameDate': '경기 날짜',
  'gameDetail.battingStats': '경기별 타격 스탯',
  'gameDetail.pitchingStats': '경기별 투구 스탯',
  'gameDetail.notFound': '경기 정보를 찾을 수 없습니다.',
  'gameDetail.noBatting': '등록된 타격 기록이 없습니다.',
  'gameDetail.noPitching': '등록된 투구 기록이 없습니다.',

  // Videos
  'videos.title': '코레밥스 영상',
  'videos.subtitle': 'Korebaps Videos',
  'videos.subscribe': '구독하기',
  'videos.nowPlaying': '재생 중',
  'videos.latestVideos': '최신 영상',
  'videos.viewAll': '전체 보기',
  'videos.loadError': '영상을 불러오지 못했습니다.',
  'videos.noVideos': '표시할 영상이 없습니다.',
  'videos.tryLater': '잠시 후 다시 시도해주세요.',
  'videos.visitChannel': '더 많은 영상을 보려면 YouTube 채널을 방문하세요!',
  'videos.viewAllYouTube': 'YouTube에서 모든 영상 보기',

  // Point Table
  'points.heading': '포인트 기준표',
  'points.rules': '코레밥스 스코어 룰',
  'points.batting': '타격',
  'points.pitching': '투구',

  // Stat tooltips (abbreviations)
  'stat.pa': '타석',
  'stat.ab': '타수',
  'stat.1b': '1루타',
  'stat.2b': '2루타',
  'stat.3b': '3루타',
  'stat.hr': '홈런',
  'stat.r': '득점',
  'stat.rbi': '타점',
  'stat.bb': '볼넷',
  'stat.hbp': '몸에 맞은 공',
  'stat.so': '삼진',
  'stat.sb': '도루',
  'stat.cs': '도루 실패',
  'stat.avg': '타율',
  'stat.obp': '출루율',
  'stat.slg': '장타율',
  'stat.ops': 'OPS (출루율+장타율)',
  'stat.war': 'WAR (대체 선수 대비 승리 기여도)',
  'stat.g': '경기 수',
  'stat.ip': '이닝',
  'stat.w': '승',
  'stat.ra': '실점',
  'stat.er': '자책점',
  'stat.h': '피안타',
  'stat.point': '타격 포인트',
  'stat.score': '점수',
  'stat.pitches': '투구수',
  'stat.era': '평균자책점',
  'stat.whip': '이닝당 출루 허용률',
  'stat.k9': '9이닝당 삼진',

  // Guide (hidden page - /guide)
  'guide.title': '코레밥스 스탯 가이드',
  'guide.subtitle': '기능 가이드 및 튜토리얼',
  'guide.pageLabel': '페이지',
  'guide.pageValue': '가이드',
  'guide.introTitle': '코레밥스 스탯 가이드에 오신 것을 환영합니다',
  'guide.introContent': '이 가이드는 코레밥스 스탯 대시보드의 주요 기능을 안내합니다. 아래 섹션을 펼쳐 앱을 더 잘 활용하는 방법을 알아보세요.',
  'guide.featuresTitle': '기능',
  'guide.quickStart': '빠른 시작',
  'guide.quickStartContent': '1. 로스터로 이동해 모든 선수를 둘러봅니다.\n2. 선수를 클릭하면 해당 선수의 기록을 볼 수 있습니다.\n3. 선수 페이지에서 "내 기록으로 고정"을 클릭하면 빠른 접근을 위해 저장됩니다.\n4. 고정한 선수는 홈 페이지 헤더에 표시됩니다.',
  'guide.dashboard': '대시보드',
  'guide.dashboardContent': '홈 페이지에는 팀 전체의 타격 및 투구 기록이 표시됩니다. 시즌 드롭다운으로 시즌별로 필터링하거나 "전체 시즌"을 선택해 커리어 합계를 볼 수 있습니다. 검색창으로 특정 선수를 찾을 수 있습니다. "은퇴 선수 포함"을 체크하면 비활성 선수도 볼 수 있습니다. 행을 클릭하면 해당 선수의 상세 페이지로 이동합니다.',
  'guide.myStats': '내 기록',
  'guide.myStatsContent': '헤더의 세 번째 카드가 "내 기록"입니다. 아직 선수를 고정하지 않았다면 로스터에서 고정하라는 안내가 표시됩니다. 고정 후에는 카드를 클릭하면 바로 해당 선수의 기록 페이지로 이동합니다.',
  'guide.playerPage': '선수 페이지',
  'guide.playerPageContent': '각 선수마다 커리어 기록, 경기별 로그, 타격 추이 차트, 시즌 비교가 있는 상세 페이지가 있습니다. 공유 버튼으로 페이지 링크를 복사할 수 있습니다. CSV 내보내기 버튼으로 커리어 기록이나 경기 로그를 다운로드할 수 있습니다.',
  'guide.compare': '선수 비교',
  'guide.compareContent': '선수 비교 페이지에서 두 명의 선수를 선택해 타격·투구 기록을 나란히 볼 수 있습니다. 팀원 비교나 성장 추적에 유용합니다.',
  'guide.export': 'CSV 내보내기',
  'guide.exportContent': 'CSV 내보내기는 대시보드(타격·투구 테이블)와 선수 페이지(커리어 기록, 경기 로그)에서 사용할 수 있습니다. "CSV 내보내기"를 클릭하면 데이터를 다운로드합니다. UTF-8로 저장되어 엑셀에서 한글이 올바르게 표시됩니다.',
  'guide.share': '공유',
  'guide.shareContent': '선수 페이지에서 공유 버튼을 사용하면 페이지 URL을 클립보드에 복사할 수 있습니다. 다른 사람에게 붙여넣어 보내면 같은 선수의 기록을 볼 수 있습니다.',
  'guide.tips': '팁: PA, OBP 등 통계 약어에 마우스를 올리면 전체 정의를 볼 수 있습니다.',

  // Admin Guide (hidden page - /admin_guide)
  'adminGuide.title': '관리자 가이드',
  'adminGuide.subtitle': '코레밥스 스탯 관리자 — 완전 참조',
  'adminGuide.pageLabel': '페이지',
  'adminGuide.pageValue': '관리자 가이드',
  'adminGuide.goToAdmin': '관리자로 이동',
  'adminGuide.confidentialTitle': '기밀 — 관리자 전용',
  'adminGuide.confidentialContent': '이 가이드는 승인된 관리자만 사용할 수 있습니다. 관리자 비밀번호나 이 가이드를 비관리자와 공유하지 마세요.',
  'adminGuide.introTitle': '관리자 대시보드 개요',
  'adminGuide.introContent': '/admin의 관리자 대시보드에서 시즌, 선수, 경기, 기록을 관리할 수 있습니다. 먼저 관리자 비밀번호로 로그인해야 합니다. 이 가이드는 모든 기능을 단계별로 안내합니다.',
  'adminGuide.sectionsTitle': '섹션',
  'adminGuide.overview': '개요',
  'adminGuide.overviewContent': '관리자에는 4개의 주요 탭이 있습니다: 선수 관리, 시즌 관리, 경기 관리, CSV 업로드. "수동 입력" 드롭다운에는 타격 기록과 투구 기록이 있습니다.\n\n작업 순서: 1) 시즌 생성. 2) 선수 추가. 3) 경기 생성. 4) CSV 또는 수동 입력으로 기록 추가. 5) 필요시 기록 수정 또는 워컵송 추가.',
  'adminGuide.login': '로그인',
  'adminGuide.loginContent': '/admin으로 이동합니다. 관리자 비밀번호를 입력하고 Sign In을 클릭합니다. 비밀번호는 백엔드에서 설정됩니다. 분실 시 시스템 관리자에게 문의하세요. 로그인 후 브라우저를 닫거나 세션이 만료될 때까지 인증이 유지됩니다.',
  'adminGuide.seasons': '시즌',
  'adminGuide.seasonsContent': '새 시즌 생성: 연도(예: 2026), Term(예: Spring, Summer, Fall) 입력, Manager는 선택 사항입니다. "시즌 생성" (Create Season) 클릭.\n\n목록에서 시즌을 클릭하면 선택되고 경기 탭으로 이동합니다. 경기를 생성하기 전에 반드시 시즌을 선택해야 합니다.',
  'adminGuide.players': '선수',
  'adminGuide.playersContent': '선수 추가: 이름, 성, 등번호, 활성(활성) 체크 후 "추가" 클릭.\n\n선수 수정: 이름 클릭으로 이름 수정, 등번호 클릭으로 번호 변경. 체크로 저장, X로 취소.\n\n활성 전환: "활성" / "비활성" 버튼으로 선수를 활성 또는 은퇴로 표시. 비활성 선수는 흐리게 표시되며, 공개 사이트에서 "은퇴 선수 포함"을 체크 해제하면 숨길 수 있습니다.',
  'adminGuide.games': '경기',
  'adminGuide.gamesContent': '경기 생성: 먼저 시즌 선택. 경기 날짜, 상대, 점수(선택) 입력. 친선 경기는 "친선" 체크. "경기 추가" 클릭.\n\n경기에 타격/투구 기록이 있으면 녹색 점, 없으면 회색 점.\n\n경기 삭제: 경기 카드의 휴지통 아이콘 클릭. 경기와 모든 타격/투구 기록이 삭제됩니다. 확인 시 주의하세요.',
  'adminGuide.editStats': '경기 기록 수정',
  'adminGuide.editStatsContent': '경기 탭에서 경기를 클릭하면 기록 수정기가 펼쳐집니다. 타격 기록과 투구 기록 섹션이 있습니다.\n\n행 수정: 행 클릭. 입력 필드가 나타남. 값 변경(타격: PA, 1B, 2B, HR 등; 투구: IP, H, R, ER, SO 등). MVP 체크. "저장" 또는 "취소" 클릭.\n\n투구 IP: 아웃 수 입력(예: 3이닝=9, 3.1이닝=10). 시스템이 이닝으로 변환합니다.',
  'adminGuide.csvUpload': 'CSV 업로드',
  'adminGuide.csvUploadContent': 'CSV 업로드로 경기별 타격·투구 기록을 일괄 추가합니다. CSV 형식:\n\n1행: 카테고리(Batting, Pitching, Fielding)\n2행: 열 헤더(타격: PA, 1B, 2B, HR, R, RBI, BB, SO, HBP, SB, CS; 투구: IP, #P, H, R, ER, SO, BB, HBP, W, L, SV)\n3행: 선수 행(등번호, 이름, 기록 값)\n\n대상 경기와 시즌 선택. CSV 업로드. 시스템이 등번호/이름으로 선수 매칭. 미리보기 확인 후 불일치 수정, 확인 후 가져오기. 해당 경기 기존 기록을 덮어씁니다.',
  'adminGuide.manualEntry': '수동 입력 (타격·투구)',
  'adminGuide.manualEntryContent': '"수동 입력" → "타격 기록" 또는 "투구 기록"으로 한 선수씩 기록 추가.\n\n경기와 선수 선택. 폼 입력(타격: PA, AB, 1B, 2B, 3B, HR 등; 투구: IP, W, K, R, ER, H, BB 등). 제출.\n\n수동 입력은 한 선수의 기록만 추가하거나 전체 CSV를 다시 올리지 않고 한 건만 수정할 때 유용합니다.',
  'adminGuide.walkup': '워컵송',
  'adminGuide.walkupContent': '선수 탭에서 선수 카드를 클릭해 선택. 오른쪽에 워컵송 섹션이 나타납니다.\n\n곡 제목, 아티스트, Spotify 트랙 ID(또는 URL) 입력. 인트로 건너뛰기 등 시작 시간(초) 설정. "저장" 클릭.\n\n트랙 ID가 있으면 선수 공개 페이지에 Spotify 임베드가 표시됩니다.',
  'adminGuide.workflow': '권장 작업 순서',
  'adminGuide.workflowContent': '1. 시즌 시작 전 시즌 생성(예: 2026 Spring).\n2. 이번 시즌 출전 선수 모두 추가. 은퇴자는 비활성 처리.\n3. 경기 후 날짜, 상대, 점수로 경기 기록 생성.\n4. 기록 추가: 전체 박스스코어가 있으면 CSV 업로드, 없으면 수동 입력.\n5. 경기 기록 수정기에서 잘못된 기록 검토·수정.\n6. 원하는 선수에게 워컵송 추가.\n\n팁: 경기 생성 전 항상 올바른 시즌을 선택하세요. 기록은 경기에, 경기는 시즌에 연결됩니다.',

  // Record Summary
  'summary.heading': '경기 요약',
  'summary.battingTop3': '타격 Top 3',
  'summary.pitchingTop3': '투구 Top 3',
  'summary.noBatting': '등록된 타격 기록이 없습니다.',
  'summary.noPitching': '등록된 투구 기록이 없습니다.',
};

export default ko;
